import { useTrackAiInsightsEvent } from '../../shared';
import type { DiscoverabilityAnalyticsEventProperties } from '../DiscoverabilityAnalyticsEvents';

const useTrackDiscoverabilityEvent = () => useTrackAiInsightsEvent<DiscoverabilityAnalyticsEventProperties>();

export default useTrackDiscoverabilityEvent;
